import { render, staticRenderFns } from "./AddManyFeaturesModal.vue?vue&type=template&id=ae78fb22"
import script from "./AddManyFeaturesModal.vue?vue&type=script&lang=js"
export * from "./AddManyFeaturesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports